'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconName", "icon", "tooltip", "placement", "onClick", "disabled", "disabledTooltip"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { TextToolbarIcon } from '../editor/TextToolbarIcon';
import UITextToolbarButton from '../editor/UITextToolbarButton';
import UITextToolbarIcon from '../editor/UITextToolbarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ToolbarButton extends Component {
  render() {
    const _this$props = this.props,
      {
        iconName,
        icon,
        tooltip,
        placement,
        onClick,
        disabled,
        disabledTooltip
      } = _this$props,
      buttonProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isTooltipDisabled = disabled && !disabledTooltip;
    const tooltipTitle = disabled ? disabledTooltip : tooltip;
    return /*#__PURE__*/_jsx(Tooltip, {
      disabled: isTooltipDisabled,
      title: tooltipTitle,
      placement: placement,
      children: /*#__PURE__*/_jsx(UITextToolbarButton, Object.assign({
        onClick: onClick,
        disabled: disabled
      }, buttonProps, {
        children: icon ? /*#__PURE__*/_jsx(TextToolbarIcon, {
          disabled: disabled,
          icon: icon
        }) :
        /*#__PURE__*/
        // @TODO: DELETE ME once all consumers have migrated to `TextToolbarIcon`
        _jsx(UITextToolbarIcon, {
          disabled: disabled,
          name: iconName
        })
      }))
    });
  }
}
ToolbarButton.propTypes = {
  iconName: PropTypes.string,
  icon: PropTypes.node,
  tooltip: PropTypes.string.isRequired,
  placement: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string
};
ToolbarButton.defaultProps = {
  placement: 'bottom'
};